<!--
    Renders nothing — it exists only to call useToast() from inside <UApp>'s
    subtree (where the toast provider is actually available via inject) and hand
    the resulting API to src/libs/toast.ts, so PrintSuccess/PrintError can use it
    later from anywhere, including async handlers where useToast() itself would fail.
-->
<template>
    <span v-once class="hidden" aria-hidden="true" />
</template>

<script lang="ts" setup>
    import { registerToastApi } from '@/libs/toast'

    registerToastApi(useToast())
</script>
